import { cn } from '@/lib/utils';

export default function H3({
    children,
    className,
}: {
    children: string | React.ReactNode;
    className?: string;
}) {
    return <h3 className={cn('text-h4 font-medium lg:text-h3', className)}>{children}</h3>;
}
